export const isOnrampMoney = window.location.origin.match(/onramp.money|.*\.?bitbns\.com/);
